import { render, staticRenderFns } from "./ProjectSubNav.vue?vue&type=template&id=105d4680&scoped=true&"
import script from "./ProjectSubNav.vue?vue&type=script&lang=js&"
export * from "./ProjectSubNav.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSubNav.vue?vue&type=style&index=0&id=105d4680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105d4680",
  null
  
)

export default component.exports